export default __webpack_public_path__ + "static/media/education.fee148ad.svg";